/* tslint:disable */
/* eslint-disable */

/**
 * deliveryProviderPortal paid-visibility api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

import { GeneratedApiClient, type GeneratedHttpClientConstraints, type RequestOptionsConstraint, HttpMethod, AuthStrategy, ShardingStrategy } from "../runtime";

import type {
    CancelSponsoredListingRequest,
    CreateCpcCampaignRequest,
    CreateCpcCampaignResponse,
    GetCpcCampaignRequest,
    GetCpcCampaignResponse,
    GetCpcForecastRequest,
    GetCpcForecastResponse,
    GetCpcInvoicesRequest,
    GetCpcInvoicesResponse,
    GetCpcSetupContextRequest,
    GetCpcSetupContextResponse,
    GetMenuItemsPreviewRequest,
    GetMenuItemsPreviewResponse,
    GetPaidVisibilityOffersRequest,
    GetPaidVisibilityOffersResponse,
    GetProviderPreviewRequest,
    GetProviderPreviewResponse,
    GetSponsoredListingRequest,
    GetSponsoredListingResponse,
    SignUpForMultipleOffersRequest,
    SignUpForMultipleOffersResponse,
    UpdateCpcCampaignRequest,
    UpdateCpcCampaignResponse,
    StandardRequest,
} from '../models/index';

export interface HttpClientConstraints {
    Auth: AuthStrategy.JWT;
    Sharding: ShardingStrategy.NONE;
    StandardRequest: StandardRequest;
}



class ApiClientClass<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> extends GeneratedApiClient<THttpClientConstraints, TRequestOptions> {
        public paidVisibilityCancelSponsoredListing = async (body: CancelSponsoredListingRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/paidVisibility/cancelSponsoredListing',
                service_id: 'paid-visibility',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public paidVisibilityCpcCreateCampaign = async (body: CreateCpcCampaignRequest, opts?: TRequestOptions): Promise<CreateCpcCampaignResponse>  => {
            return this.httpClient.sendRequest<CreateCpcCampaignResponse>({
                path: '/deliveryProviderPortal/paidVisibility/cpc/createCampaign',
                service_id: 'paid-visibility',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public paidVisibilityCpcGetCampaign = async (body: GetCpcCampaignRequest, opts?: TRequestOptions): Promise<GetCpcCampaignResponse>  => {
            return this.httpClient.sendRequest<GetCpcCampaignResponse>({
                path: '/deliveryProviderPortal/paidVisibility/cpc/getCampaign',
                service_id: 'paid-visibility',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public paidVisibilityCpcGetForecast = async (body: GetCpcForecastRequest, opts?: TRequestOptions): Promise<GetCpcForecastResponse>  => {
            return this.httpClient.sendRequest<GetCpcForecastResponse>({
                path: '/deliveryProviderPortal/paidVisibility/cpc/getForecast',
                service_id: 'paid-visibility',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public paidVisibilityCpcGetInvoices = async (body: GetCpcInvoicesRequest, opts?: TRequestOptions): Promise<GetCpcInvoicesResponse>  => {
            return this.httpClient.sendRequest<GetCpcInvoicesResponse>({
                path: '/deliveryProviderPortal/paidVisibility/cpc/getInvoices',
                service_id: 'paid-visibility',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public paidVisibilityCpcGetSetupContext = async (body: GetCpcSetupContextRequest, opts?: TRequestOptions): Promise<GetCpcSetupContextResponse>  => {
            return this.httpClient.sendRequest<GetCpcSetupContextResponse>({
                path: '/deliveryProviderPortal/paidVisibility/cpc/getSetupContext',
                service_id: 'paid-visibility',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public paidVisibilityCpcUpdateCampaign = async (body: UpdateCpcCampaignRequest, opts?: TRequestOptions): Promise<UpdateCpcCampaignResponse>  => {
            return this.httpClient.sendRequest<UpdateCpcCampaignResponse>({
                path: '/deliveryProviderPortal/paidVisibility/cpc/updateCampaign',
                service_id: 'paid-visibility',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public paidVisibilityGetAvailableOffers = async (body: GetPaidVisibilityOffersRequest, opts?: TRequestOptions): Promise<GetPaidVisibilityOffersResponse>  => {
            return this.httpClient.sendRequest<GetPaidVisibilityOffersResponse>({
                path: '/deliveryProviderPortal/paidVisibility/getAvailableOffers',
                service_id: 'paid-visibility',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public paidVisibilityGetMenuItemsPreview = async (body: GetMenuItemsPreviewRequest, opts?: TRequestOptions): Promise<GetMenuItemsPreviewResponse>  => {
            return this.httpClient.sendRequest<GetMenuItemsPreviewResponse>({
                path: '/deliveryProviderPortal/paidVisibility/getMenuItemsPreview',
                service_id: 'paid-visibility',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public paidVisibilityGetProviderPreview = async (body: GetProviderPreviewRequest, opts?: TRequestOptions): Promise<GetProviderPreviewResponse>  => {
            return this.httpClient.sendRequest<GetProviderPreviewResponse>({
                path: '/deliveryProviderPortal/paidVisibility/getProviderPreview',
                service_id: 'paid-visibility',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public paidVisibilityGetSponsoredListing = async (body: GetSponsoredListingRequest, opts?: TRequestOptions): Promise<GetSponsoredListingResponse>  => {
            return this.httpClient.sendRequest<GetSponsoredListingResponse>({
                path: '/deliveryProviderPortal/paidVisibility/getSponsoredListing',
                service_id: 'paid-visibility',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public paidVisibilitySignUpForMultipleOffers = async (body: SignUpForMultipleOffersRequest, opts?: TRequestOptions): Promise<SignUpForMultipleOffersResponse>  => {
            return this.httpClient.sendRequest<SignUpForMultipleOffersResponse>({
                path: '/deliveryProviderPortal/paidVisibility/signUpForMultipleOffers',
                service_id: 'paid-visibility',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
}
// Split class actual prototype and type
export const ApiClient = ApiClientClass;
/**
 * When you use ApiClient class as a type it would include private / protected properties which leads
 * to a situation where 2 sources of the ApiClient are not equal.
 *
 * This situation can happen for example when a library depends on the whole ApiClient and consumer wants to pass
 * in its own ApiClient. That would lead to an error
 *
 * TS2345: Argument of type 'ApiClient<HttpClientConstraints, HttpRequestOpts>' is not assignable to parameter of type 'ApiClient<HttpClientConstraints, never>'.
 *  Property 'apiClientOptions' is protected but type 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>' is not a class derived from 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>'.
 */
export type ApiClient<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> = {
    [Key in keyof ApiClientClass<THttpClientConstraints, TRequestOptions>]: ApiClientClass<THttpClientConstraints, TRequestOptions>[Key];
};
